import { render, staticRenderFns } from "./ProgramsListView.vue?vue&type=template&id=1278df5d&scoped=true&"
import script from "./ProgramsListView.vue?vue&type=script&lang=js&"
export * from "./ProgramsListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1278df5d",
  null
  
)

export default component.exports